<template>
    <div class="content">
        <TopBar barTheme="white" :barStyle="`background: url(${require('@/assets/images/personal_top_bg.png')}) no-repeat; background-size: 100%;`">
            <span class="page-title" slot="title">推荐有礼</span>
        </TopBar>
        <div class="recommend">
            <div class="part-top">
                <div class="rec-theme">
                    <img :src="recTheme" alt="推荐好友最高享12500积分">
                </div>
                <div class="rec-btn-box">
                    <a class="btn-item btn-recommend hvc" href="javascript: void(0)" @click="showType">立即推荐好友</a>
                </div>
                <div class="wechat-layer" v-if="wechatLayer" @click="closeLayer">
                    <img :src="tipImg" alt="微信分享提示">
                </div>
                <div class="browser-layer" v-if="browserLayer" @click.self="closeLayer">
                    <div class="layer-wrapper">
                        <div class="layer-title hvc">请选择分享方式</div>
                        <div class="layer-content">
                            <div class="type-item type-01">
                                <div class="type-text vc"><strong>方式1：</strong>复制链接分享发送给好友 <span class="tip-target hvc">推荐</span></div>
                                <div class="ope-wrapper vc">
                                    <span class="link">{{link}}</span>
                                    <a class="btn-item btn-copy hvc" href="javascript: void(0)" @click="copyText" :data-clipboard-text="linkText">复制链接</a>
                                </div>
                            </div>
                            <div class="type-item type-02">
                                <div class="type-text vc"><strong>方式2：</strong>推荐码分享(注册时填写)</div>
                                <div class="rec-code vc">我的推荐码<span>{{recCode}}</span></div>
                            </div>
                        </div>
                        <a class="btn-item btn-close" href="javascript: void(0)" @click="closeLayer"></a>
                    </div>
                    <div class="copy-success animated fadeInDown delay100" v-if="copySuccess">
                        <span class="hvc">链接复制成功，马上发送给好友吧！</span>
                    </div>
                </div>
            </div>
            <div class="part-main wrap">
                <div class="activity-rule hc">
                    <router-link class="hvc" tag="a" to="/recommend/activityRule"><i class="icon icon-question hvc">?</i><span>活动规则</span></router-link>
                </div>
                <div class="rec-reward">
                    <div class="reward-box">
                        <div class="box-hd vc">
                            <h3>我的奖励</h3>
                            <router-link tag="a" to="/recommend/list"><span>推荐记录</span></router-link>
                        </div>
                        <div class="box-bd">
                            <ul class="vc">
                                <li class="vc">
                                    <div class="item-data hc"><router-link tag="a" to="/recommend/list">{{ thousands(recPoints) }}</router-link><span>分</span></div>
                                    <div class="item-tip hc">累计赚取</div>
                                </li>
                                <li class="vc">
                                    <div class="item-data hc"><router-link tag="a" to="/recommend/list">{{recRegister}}</router-link><span>人</span></div>
                                    <div class="item-tip hc">成功推荐注册</div>
                                </li>
                                <li class="vc">
                                    <div class="item-data hc"><router-link tag="a" to="/recommend/list">{{recOrder}}</router-link><span>人</span></div>
                                    <div class="item-tip hc">成功推荐下单</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="methods">
                    <h3 class="methods-title hc">如何邀请赚积分</h3>
                    <div class="methods-list">
                        <ul>
                            <li class="vc">
                                <div class="icon-box hvc">
                                    <i class="icon icon-money"></i>
                                </div>
                                <div class="text-box">
                                    <h3>分享推荐好友注册</h3>
                                    <p>好友完成注册可获50美金船上消费金</p>
                                </div>
                            </li>
                            <li class="vc">
                                <div class="icon-box hvc">
                                    <i class="icon icon-order"></i>
                                </div>
                                <div class="text-box">
                                    <h3>好友完成首单有效预订</h3>
                                    <p>预订渠道需为皇家官方网站和微信小程序</p>
                                </div>
                            </li>
                            <li class="vc">
                                <div class="icon-box hvc">
                                    <i class="icon icon-data"></i>
                                </div>
                                <div class="text-box">
                                    <h3>享高达12,500积分</h3>
                                    <p>推荐人可获好友预订积分50%的推荐积分</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="part-bottom">
                <img class="logo" :src="logo" alt="logo">
                <div class="copyright">
                    <p>皇家加勒比游轮船务（中国）有限公司在法律允许的范围内对本活动保留解释权。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Clipboard from 'clipboard'
    import TopBar from '@/components/top-bar/'
    import axios from '@/libs/api.request'
    import wx from 'weixin-js-sdk'
    import shareImg from '@/assets/images/public.png'
    import { thousands, delayDev } from '@/libs/tools'
    import recTheme from '@/assets/images/share_theme.jpg'
    import logo from '@/assets/images/logo_bot.png'
    import tipImg from '@/assets/images/wechat_tip.png'
    import Cookies from 'js-cookie'
    export default {
        name: 'recommendCourtesy',
        components: {
            TopBar
        },
        data: () => {
            return {
                recTheme,
                logo,
                tipImg,
                shareImg,
                wechatLayer: false,
                browserLayer: false,
                link: '/Orchard.Rccl.Users/Login/RecommendLogin',
                linkText: '',
                copySuccess: false,
                recCode: '',
                recPoints: 0,
                recRegister: 0,
                recOrder: 0,
                cmsId: 0,
                loyaltyId: 0
            }
        },
        mounted () {
            // 检测是否登陆
            this.checkLogin()

            this.getUserId()
                .then(res => {
                    window.console.log(res)
                    // let customerInfo = res.customerInfo
                    // this.link += `?referrer=${customerInfo.Id}&mobile=${customerInfo.mobile}`
                })
            this.getRandomCode()
                .then(res => {
                    this.recCode = res.randomCode
                    this.link = `${window.location.origin}${this.link}?referralCode=${this.recCode}`
                    this.linkText = `您的好友想邀你体验皇家加勒比游轮！戳${this.link}，加入皇家游享荟领取船票福利吧！`

                    // 微信分享
                    this.share(res.lastName + res.firstName)
                    this.cmsId = res.cmsId
                    this.loyaltyId = res.loyaltyId
                })
            this.getReferrerList()
                .then(res => {
                    this.recList = res.referrerList
                    this.recPoints = res.rewardPoint
                    this.recRegister = res.registerCount
                    this.recOrder = res.successOrderCount
                    // this.sum(this.recList)
                })
        },
        methods: {
            checkLogin () {
                const cookie = Cookies.get('token')
                window.console.log(cookie, cookie === undefined)
                if (cookie === undefined) {
                    let href = window.location.href
                    window.location.href = `/Rccl.Campaign/MemberCenter/Auth?redirectUrl=${encodeURIComponent(href)}`
                }
            },
            thousands (num) {
                return thousands(num)
            },
            showType () {
                try {
                    window.gio('track', 'evt_recRegister1', {
                        'userID': this.cmsId, 
                        'loyaltyID': this.loyaltyId
                    })
                } catch (error) {
                    //console.error(error)
                }
                if (/MicroMessenger/i.test(navigator.userAgent)) {
                    this.wechatLayer = true
                } else {
                    this.browserLayer = true
                }
            },
            closeLayer () {
                this.wechatLayer = false
                this.browserLayer = false
            },
            copyText () {
                try {
                    window.gio('track', 'evt_copyRecCode', {
                        'userID': this.cmsId, 
                        'loyaltyID': this.loyaltyId
                    })
                } catch (error) {
                    //console.error(error)
                }
                let clipboard = new Clipboard('.btn-copy', {
                    text: function (trigger) {
                        return trigger.getAttribute('data-clipboard-text')
                    }
                })
                clipboard.on('success', e => {
                    window.console.log(e)
                    this.copySuccess = true
                    delayDev(3000, () => {
                        this.copySuccess = false
                    })
                    clipboard.destroy()
                })
                clipboard.on('error', e => {
                    window.console.log(e)
                    clipboard.destroy()
                })
            },
            getUserId () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserId',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            cmsId: this.$store.state.user.cmsId
                        }
                    })
                    .then(res => {
                        let data = res.data
                        if (data.errCode === 0) {
                            resolve(data.data)
                        } else if (data.errCode === 1000) {
                            window.console.log('失败')
                            
                        } else {
                            window.console.log('系统错误')
                        }
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
                })
            },
            getRandomCode () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetRandomCode',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                                window.location.href = `/Rccl.UserCenter/CustomerInfo/SignUpReward?redirectUrl=${encodeURIComponent(location.href)}`
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getReferrerList () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetReferrerList',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            sum (arr) {
                arr.map(item => {
                    this.recPoints += item.point
                    if (item.referrerStatus === 0) {
                        this.recRegister += 1
                    }
                    if (item.referrerStatus === 1) {
                        this.recOrder += 1
                    }
                })
            },
            share (name) {
                window.console.log(name)
                let link = this.link
                let imgUrl = window.location.origin + this.shareImg
                return new Promise(() => {
                    axios.request({
                        url: '/Rccl.Core/WechatPlatform/GetSignature',
                        method: 'get',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        params: {
                            url: window.location.href.split('#')[0],
                            tenantId: 1,
                            v: (new Date()).getTime()
                        }
                    })
                        .then(res => {
                            let data = res.data.data
                            window.console.log(data, wx, link, imgUrl)
                            wx.config({
                                debug: false,
                                appId: data.AppId,
                                timestamp: data.Timestamp,
                                nonceStr: data.NonceStr,
                                signature: data.Signature,
                                jsApiList: [
                                    'checkJsApi',
                                    'onMenuShareTimeline',
                                    'onMenuShareAppMessage',
                                    'onMenuShareQQ',
                                    'onMenuShareWeibo'
                                ]
                            })

                            let local_config = {
                                title: '立即领取你的50美金船上消费金！',
                                desc: `和好友一起加入“皇家游享荟”，玩转积分互动，好礼送不停！`,
                                link,
                                imgUrl
                            }

                            // 方法监听
                            wx.ready(function () {
                                window.console.log('初始化成功')
                                wx.onMenuShareAppMessage({
                                    title: local_config.title,
                                    desc: local_config.desc,
                                    link: local_config.link,
                                    imgUrl: local_config.imgUrl,
                                    success: function () {
                                        window.console.log("分享配置完成")
                                    },
                                    cancel: function () {
                                        window.console.log('分享取消')
                                    }
                                })
                                wx.onMenuShareTimeline({
                                    title: local_config.title,
                                    desc: local_config.desc,
                                    link: local_config.link,
                                    imgUrl: local_config.imgUrl,
                                    success: function () {
                                        window.console.log("分享配置完成")
                                    },
                                    cancel: function (res) {
                                        window.console.log(res)
                                    }
                                })
                                wx.onMenuShareWeibo({
                                    title: local_config.title,
                                    desc: local_config.desc,
                                    link: local_config.link,
                                    imgUrl: local_config.imgUrl,
                                    success: function () {
                                        // 用户确认分享后执行的回调函数
                                    },
                                    cancel: function () {
                                        // 用户取消分享后执行的回调函数
                                    }
                                })
                            })
                            wx.error(function (res) {
                                window.console.log('初始化失败')
                                window.console.log(res)
                            })
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .page-title{
        color: #fff;
    }
    .recommend{
        padding-top: 1.00rem;
        background-color: #f5f6f8;
        .part-top{
            .rec-theme{
                img{
                    width: 100%;
                }
            }
            .rec-btn-box{
                position: relative;
                height: 0.72rem;
                .btn-recommend{
                    display: flex;
                    display: -webkit-flex;
                    position: absolute;
                    left: 50%;
                    top: -0.62rem;
                    width: 6.30rem;
                    height: 1.04rem;
                    margin-left: -3.15rem;
                    background: url("../../../assets/images/btn_rec.png") no-repeat;
                    background-size: 100% 100%;
                    box-shadow: 0 0.15rem 0.16rem rgba(130, 105, 40, 0.28);
                    -webkit-box-shadow: 0 0.15rem 0.16rem rgba(130, 105, 40, 0.28);
                    color: #fff;
                    font-weight: bold;
                    font-size: 0.36rem;
                    text-indent: -2000px;
                }
                .gift{
                    position: absolute;
                    left: 50%;
                    top: -1.08rem;
                    width: 2.42rem;
                    height: 2.01rem;
                    margin-left: 1.30rem;
                    pointer-events: none;
                }
            }
        }
        .part-main{
            .activity-rule{
                height: 0.46rem;
                .icon-question{
                    display: flex;
                    display: -webkit-flex;
                    width: 0.28rem;
                    height: 0.28rem;
                    margin-right: 0.08rem;
                    background-color: #25388a;
                    border-radius: 100%;
                    color: #fff;
                }
            }
            .rec-reward{
                padding-top: 0.22rem;
                .reward-box{
                    background-color: #25388a;
                    border-radius: 0.12rem;
                    box-shadow: 0 0 0.15rem rgba(49, 49, 49, 0.09);
                    -webkit-box-shadow: 0 0 0.15rem rgba(49, 49, 49, 0.09);
                    .box-hd{
                        justify-content: space-between;
                        -webkit-justify-content: space-between;
                        height: 0.68rem;
                        padding: 0 0.26rem;
                        color: #fff;
                    }
                    .box-bd{
                        height: 1.68rem;
                        border: #ffa70d solid 0.02rem;
                        background-color: #fff;
                        border-radius: 0.12rem;
                        ul{
                            height: 100%;
                            li{
                                flex-wrap: wrap;
                                -webkit-flex-wrap: wrap;
                                width: 33.333333%;
                                height: 0.94rem;
                                border-right: #ffa70d solid 0.02rem;
                                &:last-child{
                                    border-right: none;
                                }
                                .item-data{
                                    width: 100%;
                                    font-size: 0.40rem;
                                    color: #ffa70d;
                                    line-height: 1;
                                    span{
                                        margin-top: 0.06rem;
                                        margin-left: 0.06rem;
                                        font-size: 0.20rem;
                                        color: #25388a;
                                    }
                                }
                                .item-tip{
                                    width: 100%;
                                    padding-top: 0.26rem;
                                    line-height: 1;
                                }
                            }
                        }
                    }
                }
            }
            .methods{
                margin-top: 0.40rem;
                padding: 0.30rem 0.36rem 0.34rem;
                border: #7581b3 solid 0.02rem;
                border-radius: 0.12rem;
                background-color: #fff;
                .methods-title{
                    font-size: 0.40rem;
                    color: #ffa70d;
                    line-height: 1;
                }
                .methods-list{
                    padding-top: 0.24rem;
                    ul{
                        li{
                            height: 1.77rem;
                            border-bottom: #e4e6e9 solid 0.02rem;
                            &:last-child{
                                border-bottom: none;
                            }
                            .icon-box{
                                width: 1.21rem;
                                height: 1.21rem;
                                background-color: #25398c;
                                border-radius: 100%;
                                .icon-money{
                                    width: 0.78rem;
                                    height: 0.78rem;
                                    background: url("../../../assets/images/rec_money.png") no-repeat;
                                    background-size: 100% 100%;
                                }
                                .icon-order{
                                    width: 0.78rem;
                                    height: 0.78rem;
                                    background: url("../../../assets/images/rec_order.png") no-repeat;
                                    background-size: 100% 100%;
                                }
                                .icon-data{
                                    width: 0.78rem;
                                    height: 0.78rem;
                                    background: url("../../../assets/images/rec_data.png") no-repeat;
                                    background-size: 100% 100%;
                                }
                            }
                            .text-box{
                                height: 0.82rem;
                                padding-left: 0.32rem;
                                line-height: 1;
                                h3{
                                    font-size: 0.36rem;
                                    color: #25388a;
                                    font-weight: normal;
                                }
                                p{
                                    margin-top: 0.24rem;
                                    font-size: 0.25rem;
                                }
                            }
                        }
                    }
                }
            }
        }
        .part-bottom{
            padding-top: 0.40rem;
            text-align: center;
            .logo{
                width: 2.74rem;
            }
            .copyright{
                padding: 0.20rem 1.06rem;
                font-size: 0.20rem;
                line-height: 0.30rem;
            }
        }
    }
    .wechat-layer{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        img{
            position: absolute;
            right: 0.63rem;
            top: 0.24rem;
            width: 4.50rem;
        }
    }
    .browser-layer{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        .layer-wrapper{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 6.90rem;
            height: 5.34rem;
            border-radius: 0.12rem;
            background-color: #fbc500;
            border: #fbc500 solid 0.02rem;
            transform: translate(-50%, -50%);
            -webkit-transform: translate(-50%, -50%);
            .layer-title{
                height: 0.80rem;
                color: #282b2c;
                font-size: 0.40rem;
                font-weight: bold;
                line-height: 1;
            }
            .layer-content{
                position: absolute;
                top: 0.80rem;
                bottom: 0;
                width: 100%;
                padding: 0 0.42rem;
                background-color: #fff;
                border-bottom-left-radius: 0.12rem;
                border-bottom-right-radius: 0.12rem;
                .type-item{
                    padding-top: 0.78rem;
                    .type-text{
                        height: 0.55rem;
                        padding-bottom: 0.20rem;
                        font-size: 0.30rem;
                        .tip-target{
                            width: 0.84rem;
                            height: 0.35rem;
                            margin-left: 0.12rem;
                            background-color: #f33c2a;
                            border-radius: 0.03rem;
                            color: #fff;
                            font-size: 0.20rem;
                            line-height: 1;
                        }
                    }
                    .ope-wrapper{
                        justify-content: space-between;
                        -webkit-justify-content: space-between;
                        height: 0.90rem;
                        border: #e5e9eb solid 0.02rem;
                        border-radius: 0.06rem;
                        .link{
                            width: 4.10rem;
                            padding: 0 0.16rem;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .btn-copy{
                            display: flex;
                            display: -webkit-flex;
                            width: 1.86rem;
                            height: 100%;
                            background-color: #fbc500;
                            font-size: 0.30rem;
                        }
                    }
                    .rec-code{
                        height: 0.48rem;
                        font-size: 0.36rem;
                        color: #ffa80d;
                        font-weight: bold;
                        line-height: 1;
                        span{
                            margin-left: 0.16rem;
                            font-size: 0.42rem;
                        }
                    }
                }
            }
            .btn-close{
                position: absolute;
                right: -0.06rem;
                top: -0.68rem;
                width: 0.60rem;
                height: 0.60rem;
                background: url("../../../assets/images/btn_close.png") no-repeat;
                background-size: 100% 100%;
            }
        }
        .copy-success{
            position: absolute;
            left: 50%;
            top: 50%;
            width: 6.90rem;
            height: 1.01rem;
            margin-left: -3.45rem;
            margin-top: 2.86rem;
            border-radius: 0.12rem;
            background-color: #25388a;
            font-size: 0.30rem;
            color: #fff;
            span{
                height: 100%;
            }
        }
    }
</style>
